<template>
  <div >
    <div class="container">
  <div class=" post">
    <div class="avatar"></div>
    <div id="line_contain" class="row">
        <div class="line l1"></div>
    <div class="line l2"></div>
    <div class="line l3"></div>
    </div>
      <div id="line_contain_bottom" class="row">
    <div class="line l1"></div>
    <div class="line l2"></div>
    <div class="line l3"></div>
    </div>
  </div>
  <div class="line divider"></div>
   <div class=" post">
    <div class="avatar"></div>
    <div id="line_contain" class="row">
        <div class="line l1"></div>
    <div class="line l2"></div>
    <div class="line l3"></div>
    </div>
      <div id="line_contain_bottom" class="row">
    <div class="line l1"></div>
    <div class="line l2"></div>
    <div class="line l3"></div>
    </div>
  </div>
    </div>
   
  </div>
</template>

<script>

export default {
  name: "SKL-Selected-Flight",
  components: {},
  props: {},
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped>
#line_contain_bottom .l1 {
    width: 20%;
}
#line_contain_bottom .l3 {
    width: 20%;
}
#line_contain_bottom .l2 {
    width: 57%;
        margin-top: 0px !important;
    height: 5px !important;
}

#line_contain .l1 {
    width: 20%;
}
#line_contain .l2 {
    width: 57%;
        height: 5px !important;
    margin-top: 19px !important;
    border-radius: 0px !important;
}
#line_contain .l3 {
    width: 20%;
}
.post {
  /* width: 220px; */
  height: 60px; 
}
.post .avatar {
  float: left;
 width: 40px;
    height: 40px;
  background-color: #ccc;
  border-radius: 25%;
  margin: 8px;
  background-image: linear-gradient(90deg, #F4F4F4 0px, rgba(229, 229, 229, 0.8) 40px, #F4F4F4 80px);
  background-size: 600px;
  animation: shine-avatar 2s infinite ease-out;
}
.post .line {
        margin-left: 1%;
  float: left;
  height: 10px;
  margin-top: 12px;
  border-radius: 7px;
  background-image: linear-gradient(90deg, #F4F4F4 0px, rgba(229, 229, 229, 0.8) 40px, #F4F4F4 80px);
  background-size: 600px;
  animation: shine-lines 2s infinite ease-out;
}
.post .avatar + .line {
  margin-top: 11px;
  width: 100px;
}
.post .line ~ .line {
  background-color: #ddd;
}

@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%, 100% {
    background-position: 140px;
  }
}
@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 208px;
  }
}
</style>


